import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Input, Button, Alert, Container, Card, CardBody, UncontrolledTooltip } from "reactstrap";
import { v4 as uuidv4 } from 'uuid';
import { Link, useNavigate } from 'react-router-dom';
import { postLogin, postSignup, getCheckUsername, sendOTPCode, postVerifyEmailOTP } from '../../helper/api-methods';
import MfaSetupPanel from '../../components/MfaSetupPanel';
import PhoneInput from 'react-phone-input-2';
import OtpInput from 'react-otp-input';
import 'react-phone-input-2/lib/style.css'
import "../../assets/css/--component-authentication.css"
import { detectUserCountry } from '../../common';
import { GoogleLogin } from '@react-oauth/google';
import disposableDomains from 'disposable-email-domains';
// import images
import logo from "../../assets/images/logo.png";
import authBanner from "../../assets/images/Login_Picture.png";
import { showToast } from '../../components/Toast';
import { getUserProfile } from '../../helper/backend-methods';

const SUPPORT_ERROR_MESSAGE = "error occured please contact wiserep support";

const DISPOSABLE_EMAIL_DOMAINS = [
    "yopmail.com",
    "mailinator.com",
    "tempmail.com",
    "temp-mail.org",
    "10minutemail.com",
    "guerrillamail.com",
    "guerrillamail.net",
    "sharklasers.com",
    "throwawaymail.com",
    "trashmail.com",
    "getnada.com",
    "emailondeck.com",
    "maildrop.cc",
    "dispostable.com",
    "fakeinbox.com",
    "mintemail.com",
];

// const isDisposableEmail = (email = "") => {
//     const domain = email.trim().toLowerCase().split("@")[1];
//     return DISPOSABLE_EMAIL_DOMAINS.includes(domain);
// };

const DISPOSABLE_EMAIL_SET = new Set(Array.isArray(disposableDomains) ? disposableDomains : (disposableDomains.default || []));
const isDisposableEmail = (email = "") => {
    const domain = (email || "").trim().toLowerCase().split("@")[1];
    if (!domain) return false;

    // exact match or subdomain match (mail.yopmail.com should match yopmail.com)
    for (const d of DISPOSABLE_EMAIL_SET) {
        if (domain === d || domain.endsWith("." + d)) return true;
    }
    return false;
};

const getErrorMessage = (error) => {
    return typeof error === "string" ? error : error?.message || SUPPORT_ERROR_MESSAGE;
};

function Signup() {

    const otpLength = 6;
    const [currentTab, setCurrentTab] = useState(1);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [signupData, setSignupData] = useState({ id: "", userName: "", password: "", repeatPassword: "", phoneNumber: "", websiteAddress: "" })
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordRepeat, setShowPasswordRepeat] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ userName: "", password: "", phoneNumber: "", websiteAddress: "", companyName: "", companyInfo: "", terms: "", apiError: "" });
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [sid, setSid] = useState("");
    const [detectedCountry, setDetectedCountry] = useState('us');
    const [isDetectingCountry, setIsDetectingCountry] = useState(true);
    const [otp, setOtp] = useState("");
    const [userId, setUserId] = useState("");
    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);
    const [mfaSetupToken, setMfaSetupToken] = useState("");
    const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
    const [manualEntryKey, setManualEntryKey] = useState("");
    const [authToken, setAuthToken] = useState("");

    document.title = "WiseRep";
    const history = useNavigate();

    useEffect(() => {
        let interval;
        if (currentTab === 2 && timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            setCanResend(true);
        }

        return () => clearInterval(interval);
    }, [currentTab, timer]);

    useEffect(() => {
        const detectCountry = async () => {
            setIsDetectingCountry(true);
            try {
                const countryCode = await detectUserCountry();
                setDetectedCountry(countryCode);
            } catch (error) {
                console.error('Failed to detect country:', error);
            } finally {
                setIsDetectingCountry(false);
            }
        };

        detectCountry();
    }, []);

    const validateGoogleLogin = (credentials) => {
        setLoading(true)
        postLogin("/auth/google", { accessToken: credentials }).then((data) => {
            localStorage.setItem("authToken", data.token)
            localStorage.setItem("userName", data.userObj.username)
            localStorage.setItem("userId", data.userObj._id)
            // localStorage.setItem("user", JSON.stringify({ name: data.fullName, picture: data.profilePictureUrl }))
            if (data.userObj.isTrialUser && !data.userObj.getting_started.isCompleted) {
                history('/get-started');
            }
            else {
                history('/');
            }
        }).catch((e) => {
            showToast("error", "Request Failed", getErrorMessage(e));
            setLoading(false);
        });
    }

    const sendEmailHandler = async () => {
        setLoading(true);
        try {
            const data = await sendOTPCode("/otp/signup-email", { username: signupData.userName });
            if (data.message === "OTP sent successfully") {
                showToast("success", "OTP Sent", "Please check your mail for the OTP.");
                setLoading(false);
                return true;
            } else {
                showToast("error", "Error", data.message);
                setLoading(false);
                return false;
            }
        } catch (e) {
            console.log("error", e);
            setLoading(false);
            return false;
        }
    }

    const verifyEmailHandler = () => {
        return postVerifyEmailOTP("/otp/verify", { otp: Number(otp), username: signupData.userName })
            .then((data) => {
                console.log("verify data", data);
                return data.success;
            })
            .catch((e) => {
                console.log("error", e);
                return false;
            });
    }

    const nextStep = async (step, validate = true) => {
        if (!validate) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setCurrentTab(step);
        }
        if (step === 2) {
            let flag = false;
            const error = { userName: "", password: "", repeatPassword: "", phoneNumber: "", terms: "", apiError: "" };
            if (!signupData.userName || signupData.userName.replaceAll(/\s/g, '').length < 3 || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(signupData.userName)) {
                error.userName = 'Please provide a valid username or email';
                flag = true
            } else if (isDisposableEmail(signupData.userName)) {
                error.userName = "Disposable email addresses are not allowed. Please use a valid business or personal email.";
                flag = true;
            }
            if (!signupData.password || !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/.test(signupData.password)) {
                error.password = 'Password must contain at least 8 character, one upper and lowercase letter, one digit and one special character';
                flag = true
            }
            if (signupData.password !== signupData.repeatPassword) {
                error.repeatPassword = 'Password do not match';
                flag = true
            }
            if (!signupData.phoneNumber || signupData.phoneNumber.length < 10) {
                error.phoneNumber = 'Please provide a valid phone number to proceed.';
                flag = true
            }
            if (!termsAccepted) {
                error.terms = 'You must accept the terms and conditions to proceed.';
                flag = true
            }
            if (!flag) {
                setLoading(true)
                window.scrollTo({ top: 0, behavior: 'smooth' });
                getCheckUsername("/user/check", { username: signupData.userName }).then((data) => {
                    if (!data.isExist) {
                        sendEmailHandler().then((emailResponse) => {
                            if (emailResponse) {
                                setCurrentTab(2);
                                setOtp("");
                                setTimer(60);
                                setCanResend(false);

                                let userData = {
                                    password: signupData.password,
                                    username: signupData.userName,
                                    phone: signupData.phoneNumber,
                                }
                                postSignup("/auth/signup", userData).then((data) => {
                                    setLoading(false)
                                    if (data.mfaSetupToken) {
                                        // MFA is enabled: signup returns a setup challenge, not a token yet.
                                        setSignupData((prev) => { return { ...prev, id: data.userId } })
                                        setUserId(data.userId);
                                        setMfaSetupToken(data.mfaSetupToken);
                                        setQrCodeDataUrl(data.qrCodeDataUrl);
                                        setManualEntryKey(data.manualEntryKey);
                                    } else {
                                        // MFA disabled (MFA_ENABLED=false on the backend): signup returns a full token directly.
                                        // Note: the backend spreads a raw (non-lean) Mongoose document here, so schema
                                        // fields land under `_doc`, not at the top level (only `accessToken` is top-level).
                                        setSignupData((prev) => { return { ...prev, id: data._doc._id } })
                                        setUserId(data._doc._id);
                                        setAuthToken(data.accessToken);
                                        localStorage.setItem("userName", data._doc.username);
                                    }
                                }).catch((e) => {
                                    showToast("error", "Request Failed", getErrorMessage(e));
                                    setLoading(false);
                                });
                                if ('credentials' in navigator && 'PasswordCredential' in window) {
                                    const cred = new window.PasswordCredential({
                                        id: signupData.userName,
                                        password: signupData.password
                                    });

                                    navigator.credentials.store(cred)
                                        .then(() => {
                                            console.log('Credentials stored!');
                                        })
                                        .catch((err) => {
                                            console.error('Error storing credentials:', err);
                                        });
                                } else {
                                    console.warn('Credential Management API not supported on this browser');
                                }
                            } else {
                                showToast("error", "OTP Failed", 'Failed to send OTP to the provided email. Please try again.');
                            }
                        });

                    } else {
                        error.apiError = 'Username or Email already exist.';
                    }
                    setLoading(false)
                }).catch((e) => {
                    showToast("error", "Request Failed", getErrorMessage(e));
                    setLoading(false);
                });
            }
            setErrors(error);
        }
        if (step === 3) {
            let flag = false;
            const error = { userName: "", password: "", repeatPassword: "", phoneNumber: "", otp: "", apiError: "" };
            if (!otp || otp.length < 5) {
                error.otp = 'Please provide a valid OTP to proceed.';
                flag = true
            }
            setErrors(error);
            if (!flag) {
                const verifyEmailResponse = await verifyEmailHandler();
                if (verifyEmailResponse) {
                    if (mfaSetupToken) {
                        showToast("success", "OTP Verified", "Now set up your authenticator app to finish signing up.");
                        setCurrentTab(3);
                    } else {
                        localStorage.setItem("authToken", authToken);
                        localStorage.setItem("userId", userId);
                        showToast("success", "OTP Verified", "Welcome to Wiserep.");
                        history('/get-started');
                    }
                } else {
                    showToast("error", "OTP Verification Failed", "We could not verify the OTP you provided. Please check the OTP and try again.");
                }

            }
        }
    }

    const handleMfaSetupVerified = (data) => {
        localStorage.setItem("authToken", data.accessToken);
        localStorage.setItem("userName", data.username);
        localStorage.setItem("userId", data._id);
        showToast("success", "Account Verified", "Welcome to Wiserep.");
        history('/get-started');
    }

    const resetForm = () => {
        setUsername("");
        setPassword("");
    }
    const resetErrors = () => {
        const error = { userName: "", password: "", phoneNumber: "", apiError: "" }
        setErrors(error);
    }

    const handleResendOTP = async () => {
        setTimer(60);
        setCanResend(false);
        setOtp("");
        await sendEmailHandler();
    };

    return (
        <div>
            <Container fluid className="p-0 bg-white">
                {
                    <Row className="g-0 d-flex align-items-center" >
                        <Col lg={6} style={{ height: "100vh" }}>
                            <div className="d-flex flex-column justify-content-center align-items-start">
                                <div className="authentication-bg d-flex justify-content-center align-items-center w-100">
                                    <div className="p-4 d-flex align-items-center z-index-2 position-relative w-100">
                                        <div className="w-100">
                                            <Row className="justify-content-center pt-1 ">
                                                <Col lg={12} className='align-items-center'>
                                                    <div style={{ width: "100%", maxWidth: "680px" }} className='mx-auto'>
                                                        <div className="text-center">
                                                            <div>
                                                                <Link to="/" className="">
                                                                    <img src={logo} alt="" height="60" className="auth-logo mx-auto" />
                                                                </Link>
                                                            </div>
                                                        </div>
                                                        {errors.apiError ? <Alert color="danger">{errors.apiError}</Alert> : null}
                                                        <div className="p-2">
                                                            <form className="form-horizontal" autoComplete='off'>
                                                                {
                                                                    currentTab === 1 ?
                                                                        <>
                                                                            <div className='text-center'>
                                                                                <h3 className="fs-34 fw-500 mt-2 text-dark">Create your Account</h3>
                                                                                <p className="text-gray-200 p-0 mb-4 m-0">Provide your details</p>
                                                                            </div>
                                                                            <div className="auth-form-group-custom mb-2">
                                                                                <Input id="username" name="username" value={signupData.userName} autoComplete='off' onChange={(e) => setSignupData((prev) => { return { ...prev, userName: e.target.value.slice(0, 50) } })} type="text" className={`form-control text-gray-100 ${errors.userName ? "is-invalid" : ""}`} placeholder="Email Address" style={{ border: '1px solid #f1f1f1', WebkitTextFillColor: '#939393', WebkitBoxShadow: '0 0 0px 1000px #f1f1f1 inset', transition: 'background-color 5000s ease-in-out 0s', }} />
                                                                                {errors.userName ? <div className="invalid-feedback">{errors.userName}</div> : null}
                                                                            </div>
                                                                            <div className="auth-form-group-custom mb-2 position-relative" id='passwordInfo'>
                                                                                <Input name="password" value={signupData.password} autocomplete="new-password" onChange={(e) => setSignupData((prev) => { return { ...prev, password: e.target.value.slice(0, 50) } })} type={showPassword ? "text" : "password"} className={`form-control`} id="userpassword" placeholder="Password" style={{ border: '1px solid #f1f1f1', WebkitTextFillColor: '#939393', WebkitBoxShadow: '0 0 0px 1000px #f1f1f1 inset', transition: 'background-color 5000s ease-in-out 0s', }} />
                                                                                <i
                                                                                    className={`ri-${showPassword ? "eye-off" : "eye"}-line show-hide-password-icon`}
                                                                                    onClick={() => setShowPassword((prev) => !prev)}
                                                                                ></i>
                                                                                <UncontrolledTooltip placement="top" style={{ minWidth: "250px" }} popperClassName="text-left" innerClassName="text-left" target={`passwordInfo`}>
                                                                                    {
                                                                                        <ul className='m-0 pl-3 text-left' >
                                                                                            <li className='mb-1 mt-0 text-left'>Password must contain at least 8 characters</li>
                                                                                            <li className='mb-1 mt-0 text-left'>One uppercase letter</li>
                                                                                            <li className='mb-1 mt-0 text-left'>One lowercase letter</li>
                                                                                            <li className='mb-1 mt-0 text-left'>One digit</li>
                                                                                            <li className='mb-1 mt-0 text-left'>One special character</li>
                                                                                        </ul>

                                                                                    }
                                                                                </UncontrolledTooltip>
                                                                            </div>
                                                                            {errors.password ? <div className="invalid-feedback mb-2">{errors.password}</div> : null}
                                                                            <div className="auth-form-group-custom mb-2 position-relative">
                                                                                <Input name="password" autocomplete="new-password" value={signupData.repeatPassword} onChange={(e) => setSignupData((prev) => { return { ...prev, repeatPassword: e.target.value.slice(0, 50) } })} type={showPasswordRepeat ? "text" : "password"} className={`form-control`} id="userpassword" placeholder="Re-type Password" style={{ border: '1px solid #f1f1f1', WebkitTextFillColor: '#939393', WebkitBoxShadow: '0 0 0px 1000px #f1f1f1 inset', transition: 'background-color 5000s ease-in-out 0s', }} />
                                                                                <i
                                                                                    className={`ri-${showPassword ? "eye-off" : "eye"}-line show-hide-password-icon`}
                                                                                    onClick={() => setShowPasswordRepeat((prev) => !prev)}
                                                                                ></i>
                                                                            </div>
                                                                            {errors.repeatPassword ? <div className="invalid-feedback mb-2">{errors.repeatPassword}</div> : null}
                                                                            {/* <div className="auth-form-group-custom mb-2">
                                                                                <Input name="phone" value={signupData.phoneNumber} onChange={(e) => setSignupData((prev) => { return { ...prev, phoneNumber: e.target.value.slice(0, 50) } })} type="text" className={`form-control text-gray-100 ${errors.username ? "is-invalid" : ""}`} id="phone" placeholder="Phone Number (Optional)" style={{ border: '1px solid #f1f1f1', WebkitTextFillColor: '#939393', WebkitBoxShadow: '0 0 0px 1000px #f1f1f1 inset', transition: 'background-color 5000s ease-in-out 0s', }} />
                                                                            </div> */}
                                                                            <PhoneInput
                                                                                country={detectedCountry}
                                                                                autoFormat={true}
                                                                                value={signupData.phoneNumber}
                                                                                onChange={(value) => setSignupData((prev) => { return { ...prev, phoneNumber: value } })}
                                                                                countryCodeEditable={false}
                                                                                inputStyle={{ width: "100%", border: '1px solid #f1f1f1', WebkitTextFillColor: '#939393', WebkitBoxShadow: '0 0 0px 1000px #f1f1f1 inset', transition: 'background-color 5000s ease-in-out 0s', }}
                                                                                dropdownStyle={{ border: "none !important", outline: "none" }}
                                                                            />
                                                                            {errors.phoneNumber ? <div className="invalid-feedback">{errors.phoneNumber}</div> : null}

                                                                            <div className="form-check mt-3">
                                                                                <Input
                                                                                    type="checkbox"
                                                                                    id="terms"
                                                                                    checked={termsAccepted}
                                                                                    onChange={(e) => setTermsAccepted(e.target.checked)}
                                                                                    className="form-check-input"
                                                                                />
                                                                                <label className="form-check-label ms-1" htmlFor="terms" style={{ lineHeight: "1.4" }}>
                                                                                    I have read and agree to WiseRep's <a href="https://wiserep.com/terms/" target="_blank" className='text-gradient' rel="noopener noreferrer">Terms & Conditions</a> and <a href="https://wiserep.com/privacy/" target="_blank" className='text-gradient' rel="noopener noreferrer">Privacy Policy</a>
                                                                                </label>
                                                                                {errors.terms ? <div className="invalid-feedback d-block">{errors.terms}</div> : null}
                                                                            </div>

                                                                            <div className="mt-3 text-left">
                                                                                <Link to="/login" className="text-gray-200"><i className="mdi mdi-lock me-1"></i> Already have an account, Login</Link>
                                                                            </div>
                                                                            <div className="mt-4 text-center">
                                                                                <Button disabled={loading} onClick={() => { nextStep(2) }} className="btn-lg w-100 linear-gradient-btn">{loading ? "Please Wait" : "Next"}</Button>
                                                                            </div>
                                                                        </>
                                                                        : currentTab === 2 ?
                                                                            <>
                                                                                <div className='text-center'>
                                                                                    <h3 className="fs-34 fw-500 mt-2 text-dark">Verify your Account</h3>
                                                                                    <p className="text-gray-200 p-0 mb-4 m-0">Provide OTP sent to <span className="fw-500">{signupData.userName}</span></p>
                                                                                </div>
                                                                                <div className="d-flex justify-content-center gap-2 mb-4">
                                                                                    <OtpInput
                                                                                        value={otp}
                                                                                        onChange={setOtp}
                                                                                        numInputs={6}
                                                                                        shouldAutoFocus={true}
                                                                                        renderSeparator={<span> </span>}
                                                                                        renderInput={(props) => <input {...props} />}
                                                                                        inputStyle={{ width: "60px", height: "60px", borderRadius: "7px", border: "none", backgroundColor: "#f1f1f1", fontSize: "20px" }}
                                                                                        containerStyle={"otp-input"}

                                                                                    />
                                                                                </div>
                                                                                <Row>
                                                                                    <Col md={6}>
                                                                                        <div className="mt-2 text-left">
                                                                                            {canResend ? (
                                                                                                <Link className="text-gray-200" onClick={handleResendOTP}>
                                                                                                    Didn't receive the email? Resend OTP
                                                                                                </Link>
                                                                                            ) : (
                                                                                                <span className="text-primary">
                                                                                                    Resend OTP in <span className="fw-600">{String(Math.floor(timer / 60)).padStart(2, '0')}:{String(timer % 60).padStart(2, '0')}</span>
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col md={6}>
                                                                                        <div className="mt-2 text-right">
                                                                                            <Link onClick={() => setCurrentTab(1)} className="text-gray-200">Use another email? Go Back</Link>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row>
                                                                                    <Col md={12} className='text-center'>
                                                                                        <div className="mt-4 text-center">
                                                                                            <Button disabled={loading} onClick={() => { nextStep(3) }} className="btn-lg w-100 linear-gradient-btn">{loading ? "Please Wait" : "Verify Email"}</Button>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>
                                                                            </>
                                                                            :
                                                                            <MfaSetupPanel
                                                                                qrCodeDataUrl={qrCodeDataUrl}
                                                                                manualEntryKey={manualEntryKey}
                                                                                mfaSetupToken={mfaSetupToken}
                                                                                onVerified={handleMfaSetupVerified}
                                                                            />
                                                                }
                                                            </form>
                                                            {/* <div className="mt-4 d-flex justify-content-center align-items-center">
                                                                <span className="w-100 login-separator"></span>
                                                                <span className='w-100 text-center continue-with'>Or continue with</span>
                                                                <span className='w-100 login-separator'></span>
                                                            </div> */}
                                                            {/* <div className="mt-4 text-center">
                                                                <Button disabled={loading} className="btn-lg w-100 font-normal" style={{ background: "#0976B4", border: "none", display: "flex", justifyContent: "center", alignItems: "center", columnGap: "10px" }}><img src={linkedInLogo} width={30} height={30} /> Sign in with Linkedin</Button>
                                                            </div> */}
                                                            {/* <div className="mt-3 text-center">
                                                                <Button disabled={loading} onClick={() => login()} className="btn-lg w-100 text-black font-normal" style={{ background: "transparent", border: "1px solid #ddd", display: "flex", justifyContent: "center", alignItems: "center", columnGap: "10px" }}><img src={googleLogo} width={30} height={30} /> Sign in with Google</Button>
                                                            </div> */}
                                                            {/* <div className="mt-3 text-center w-35 ms-auto me-auto">
                                                                <GoogleLogin
                                                                    onSuccess={async (credentialResponse) => {
                                                                        try {
                                                                            validateGoogleLogin(credentialResponse.credential)
                                                                        } catch (err) {
                                                                            console.error(err);
                                                                        }
                                                                    }}
                                                                    onError={() => {
                                                                        console.log("Login Failed");
                                                                    }}
                                                                />
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="d-none d-lg-block p-0">
                            {/* Aurora panel — see Login.js. Composed in CSS so it tracks
                                the brand tokens rather than being baked into a raster. */}
                            <div className="auth-aurora">
                                <span className="auth-aurora__eyebrow">
                                    <i className="ri-rocket-2-line" /> Live in under a day
                                </span>
                                <h2 className="auth-aurora__title">Never miss a call, again.</h2>
                                <p className="auth-aurora__sub">
                                    A 24/7 AI receptionist that answers every call, in every
                                    language, and books the meeting for you.
                                </p>
                                <div className="auth-aurora__frame">
                                    <img src={authBanner} alt="" />
                                </div>
                            </div>
                        </Col>
                    </Row>
                }
            </Container>
        </div>

    );

}


export default Signup